import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const submitQuote = async (payload) => {
    const { data } = await axios.post(`${API}/quote`, payload, { timeout: 15000 });
    return data;
};

export const submitContact = async (payload) => {
    const { data } = await axios.post(`${API}/contact`, payload, { timeout: 15000 });
    return data;
};

export const submitReview = async (payload) => {
    const { data } = await axios.post(`${API}/reviews`, payload, { timeout: 15000 });
    return data;
};

export const fetchReviews = async () => {
    const { data } = await axios.get(`${API}/reviews`, { timeout: 15000 });
    return data;
};
